'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { Button } from '@/components/ui/button';
import { Form, FormField, FormItem } from '@/components/ui/form';
import { FormInput } from '@/components/ui/form-inputs/form-input';
import { getResponse } from '@/utils';
import { handleFormSubmit } from '@/utils/form-submit-handler';

const formSchema = z.object({
  email: z.string().email('E-mailová adresa není validní.').min(5, 'E-mailová adresa je povinná.'),
});

export type FormInputs = z.infer<typeof formSchema>;

export const ResetForm = () => {
  const form = useForm<FormInputs>({
    resolver: zodResolver(formSchema),
    reValidateMode: 'onBlur',
    defaultValues: {
      email: '',
    },
  });

  const onSubmit: SubmitHandler<FormInputs> = data => handleFormSubmit(form, {
    submitFn: () => getResponse('postApiV1AuthReset', { email: data.email }),
    toastError: { title: 'Chyba' },
    toastSuccess: { title: 'Změna hesla', description: `Odkaz na změnu hesla byl odeslán na ${data.email}` },
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-8"
      >
        <FormField
          name="email"
          control={form.control}
          render={({ field }) => (
            <FormItem className="relative">
              <FormInput
                label="Vaše e-mailová adresa"
                id="email-input"
                type="email"
                placeholder="Email"
                {...field}
              />
            </FormItem>
          )}
        />

        <Button
          data-testid="cypress-reset-password-button"
          className="mt-4"
          variant="primary"
          size="primary"
          type="submit"
        >
          Obnovit heslo
        </Button>
      </form>
    </Form>
  );
};
